import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "dvCustomDropdowm",
  class: "dropdown-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "empty-list"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "filter-name" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "dropdown form-control",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ToggleDropDown && _ctx.ToggleDropDown(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["secondary-dropdown cursor-default", {'selected-item': _ctx.selectedItem.Id !== 0}])
          }, [
            _createElementVNode("span", {
              class: "selected-item-name",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.EditItem(_ctx.selectedItem.Id)))
            }, _toDisplayString(_ctx.GetFilterText()), 1),
            (_ctx.selectedItem.Id !== 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "cross-icon",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.RemoveItem && _ctx.RemoveItem(...args)), ["stop"]))
                }, [
                  _createElementVNode("img", { src: _ctx.crossIcon }, null, 8, _hoisted_2)
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("ul", {
            class: _normalizeClass(["dropdown-menu", {'show': _ctx.showDropDown}])
          }, [
            (_ctx.localCustomDropdownData.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_ctx.emptyPlaceholder), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.localCustomDropdownData, (data) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: data,
                    class: "filter-list cursor-default",
                    onClick: ($event: any) => (_ctx.SelectFilter(data))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.selectedItem.Id === data.Id)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.tickIcon
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass([_ctx.showTickIcon && _ctx.selectedItem.Id === data.Id ? 'margin-left-10': {'margin-left-25': _ctx.showTickIcon} ])
                      }, _toDisplayString(data.Name), 3)
                    ])
                  ], 8, _hoisted_4))
                }), 128))
          ], 2),
          _createElementVNode("img", { src: _ctx.arrowDownIcon }, null, 8, _hoisted_7)
        ])), [
          [_directive_click_outside, _ctx.HideDropDown]
        ])
      ]))
    : _createCommentVNode("", true)
}